import { TrapStatus } from 'api/InteractiveMap/types';

export const MarkersColors: Record<string, string> = {
  warning: '#f2bb4e',
  danger: '#ef6149',
  dark: '#878a99',
  medium: '#f1963b',
};

export const DevicesColors: Record<string, string> = {
  warning: '#f2bb4e',
  danger: '#ef6149',
  success: '#90c650',
  dark: '#878a99',
};

export const getDeviceColor = (status: TrapStatus) => {
  switch (status) {
    case TrapStatus.success:
      return DevicesColors.success;
    case TrapStatus.warning:
      return DevicesColors.warning;
    case TrapStatus.danger:
      return DevicesColors.danger;
    default:
      return DevicesColors.dark;
  }
};
